const IconY = ({ className, ...reset }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className={`eco-icon-checkbox-n${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <path
                d="M16 2C17.1046 2 18 2.89543 18 4V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V4C2 2.89543 2.89543 2 4 2H16ZM14.5068 6.44727C14.2015 6.1674 13.7272 6.18791 13.4473 6.49316L8.5 11.8896L6.55273 9.76562C6.27283 9.46052 5.79843 9.43995 5.49316 9.71973C5.18784 9.9996 5.16743 10.474 5.44727 10.7793L7.94727 13.5068C8.08932 13.6618 8.28981 13.75 8.5 13.75C8.71019 13.75 8.91068 13.6618 9.05273 13.5068L14.5527 7.50684C14.8326 7.20153 14.8121 6.72717 14.5068 6.44727Z"
                fill="black"
            />
        </svg>
    );
};

const IconN = ({ className, ...reset }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="none"
            className={`eco-icon-checkbox-n${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <mask id="path-1-inside-1_260_1713" fill="white">
                <path d="M2 3.33333C2 2.59695 2.59695 2 3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333Z" />
            </mask>
            <path
                d="M3.33333 3.5H12.6667V0.5H3.33333V3.5ZM12.5 3.33333V12.6667H15.5V3.33333H12.5ZM12.6667 12.5H3.33333V15.5H12.6667V12.5ZM3.5 12.6667V3.33333H0.5V12.6667H3.5ZM3.33333 12.5C3.42538 12.5 3.5 12.5746 3.5 12.6667H0.5C0.5 14.2315 1.76853 15.5 3.33333 15.5V12.5ZM12.5 12.6667C12.5 12.5746 12.5746 12.5 12.6667 12.5V15.5C14.2315 15.5 15.5 14.2315 15.5 12.6667H12.5ZM12.6667 3.5C12.5746 3.5 12.5 3.42538 12.5 3.33333H15.5C15.5 1.76853 14.2315 0.5 12.6667 0.5V3.5ZM3.33333 0.5C1.76853 0.5 0.5 1.76853 0.5 3.33333H3.5C3.5 3.42538 3.42538 3.5 3.33333 3.5V0.5Z"
                fill="#000"
                mask="url(#path-1-inside-1_260_1713)"
            />
        </svg>
    );
};

export { IconY, IconN };
